import Character from "@lss/common/src/shell/Character";
import { TimageINT } from "../../src/store/slices/gameObjectSlice";
import { parseRequire } from "../../src/utils/parseImageUrl";
import { othersProfilesPics } from "../helpers/othersInstaPhoneImages";



interface JennyPropertiesINT {

    instaProfileImage: TimageINT & { key?: string; },
}

const jennyProperties: JennyPropertiesINT = {
    instaProfileImage: othersProfilesPics.JennyProfilePic1

};

const jenny = new Character<JennyPropertiesINT>("Jenny", jennyProperties, "#FF63C7FF");



export {
    jenny,
};
